import { useState } from 'react';
import {
  handleClaimRewardPopupAction,
  needSelectServiceNumber,
  shouldClaimDirectly,
} from '../utils/rewardClaim';

const useRewardClaimFlow = ({
  form,
  dispatch,
  chooseSubNumMethod,
  pageRenderDetail,
  refreshAfterClaim,
}) => {
  const [claimSuccessVisible, setClaimSuccessVisible] = useState(false);
  const [rewardDetail, setRewardDetail] = useState({});
  const [modelVis, setModalVis] = useState(false);

  const handleClaimed = async claimDetail => {
    const { rewardInstanceId } = claimDetail || {};
    dispatch({
      type: 'myAwards/claimRewardDXP',
      payload: { rewardInstanceId },
    }).then(res => {
      if (res) {
        setModalVis(false);
        refreshAfterClaim?.();
        setClaimSuccessVisible(true);
      }
    });
  };

  const handleClaimReward = claimDetail => {
    if (shouldClaimDirectly(claimDetail, chooseSubNumMethod)) {
      handleClaimed(claimDetail);
      return;
    }
    if (needSelectServiceNumber(claimDetail, chooseSubNumMethod)) {
      setRewardDetail(claimDetail);
      setModalVis(true);
    }
  };

  const handleCloseModal = () => {
    const { setFieldsValue } = form;
    setFieldsValue({
      serviceNumber: null,
    });
    setModalVis(false);
  };

  const handleClickClaimBtn = async () => {
    const { validateFields } = form;
    const formInfo = (await validateFields()) || {};
    handleClaimed({ ...rewardDetail, serviceNumber: formInfo.serviceNumber });
  };

  const handleJumpLink = () => {
    handleClaimRewardPopupAction(pageRenderDetail, () => setClaimSuccessVisible(false));
  };

  return {
    claimSuccessVisible,
    modelVis,
    setClaimSuccessVisible,
    handleClaimReward,
    handleCloseModal,
    handleClickClaimBtn,
    handleJumpLink,
  };
};

export default useRewardClaimFlow;
